"use client";

import { invariant } from "@offstreetparking/domain/exceptions";
import { type ReactNode, createContext, useContext, useMemo } from "react";

type KioskContextValue = {
	isKiosk: boolean;
	startOverLookupId: string | undefined;
};

const KioskContext = createContext<KioskContextValue | null>(null);

type KioskProviderProps = {
	children: ReactNode;
	isKiosk?: boolean;
	startOverLookupId?: string;
};

export const KioskProvider = ({ children, isKiosk = false, startOverLookupId }: KioskProviderProps) => {
	const value = useMemo(() => ({ isKiosk, startOverLookupId }), [isKiosk, startOverLookupId]);

	return <KioskContext.Provider value={value}>{children}</KioskContext.Provider>;
};

export const useKiosk = (): KioskContextValue => {
	const context = useContext(KioskContext);

	invariant(context, "useKiosk must be used within a KioskProvider");

	return context;
};
